import React, { useEffect, useState } from 'react';
import apis from '../../config/apis.json';

const api =
  process.env.REACT_APP_ENVIRON === 'development'
    ? apis.dev
    : process.env.REACT_APP_ENVIRON === 'production'
    ? apis.prod
    : apis.test;

/**
 * /activate?token=<uuid>
 *
 * Redirects the browser to the platform-server activation endpoint, which
 * validates the magic-link token and redirects to WorkOS AuthKit.
 * This page is intentionally thin — the real logic lives server-side.
 * 
 * 
 * http://localhost:3000/activate?token=HVVtVbmpE03JKS0X926w5DuwuIUK8I3nzYULa4d7hZ30iHZP
 * 
 */
const Activate = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setError('Invalid activation link. Please check your email and try again.');
      return;
    }

    // Full browser redirect — the server will validate the token and redirect
    // to WorkOS AuthKit. After auth, workOsCallback redirects to the customer
    // company jobs page.
    window.location.href = `${api}/user/activate?token=${encodeURIComponent(token)}`;
  }, []);

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'Arial, sans-serif', background: '#f9f9f9' }}>
        <div style={{ maxWidth: 480, padding: 32, background: '#fff', borderRadius: 10, border: '1px solid #e0e0e0', textAlign: 'center' }}>
          <h2 style={{ color: '#404880', marginBottom: 12 }}>Invalid Link</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>{error}</p>
          <a href="https://officer.app/request-officer" style={{ color: '#404880', fontWeight: 600 }}>Submit a new request →</a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'Arial, sans-serif', background: '#f9f9f9' }}>
      <div style={{ textAlign: 'center', color: '#666' }}>
        <p>Activating your account…</p>
      </div>
    </div>
  );
};

export default Activate;
